export const SocialMedia = (value) => {
    if(value == 'facebook'){
        window.open("https://www.facebook.com/people/Flint-Infotech/61555756808126/", "_blank");
    }
    if(value == 'instagram'){
        window.open("https://www.instagram.com/flintinfotech?igsh=MThtd2w3OXJveHdrZA==", "_blank");
    }
}